import {
  GET_SURGE_TEMPLATE_DETAILS,
  GET_SURGE_TEMPLATE_DETAILS_SUCCESS,
  GET_SURGE_TEMPLATE_DETAILS_ERROR,
  GET_SURGE_TEMPLATE_DETAILS_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSurgeTemplateDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURGE_TEMPLATE_DETAILS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_TEMPLATE_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_TEMPLATE_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SURGE_TEMPLATE_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSurgeTemplateDetails;
